import { Box, Card, Skeleton } from '@mui/material';

function AudioCardSkeleton() {
  return (
    <Card
      sx={{
        boxShadow: 3,
        borderRadius: 3,
        p: 2,
        m: 0,
        bgcolor: 'background.paper',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <Skeleton variant="circular" width={24} height={24} sx={{ mr: 1 }} />
        <Skeleton variant="text" width="40%" />
        <Skeleton
          variant="rectangular"
          width={60}
          height={20}
          sx={{ ml: 'auto' }}
        />
      </Box>

      <Skeleton variant="text" sx={{ mb: 2 }} />
      <Skeleton variant="text" width="80%" sx={{ mb: 2 }} />

      <Skeleton variant="rectangular" height={40} sx={{ width: '100%' }} />
    </Card>
  );
}

export default AudioCardSkeleton;
